import { formatPrice } from '@polaris/core/utils'
import { useAtomValue } from 'jotai'
import {
  additionalFeesAtom,
  gasStepAtom,
  isUserRejectionErrorAtom,
  routeAtom,
} from '@/src/stores/route-machine/atoms'
import { BasicStepRow, BasicStepRowTitle } from './basic-step-row'

const Title = () => {
  const additionalFees = useAtomValue(additionalFeesAtom)
  const route = useAtomValue(routeAtom)
  const totalFees =
    route?.FeeRequirements?.gas_station?.total_usd_to_fund ??
    additionalFees ??
    0
  const isHistoricalGasStationFundSuccess =
    route?.isHistoricalGasStationFundSuccess

  return (
    <BasicStepRowTitle
      title={`${isHistoricalGasStationFundSuccess ? 'Pre-paid' : 'Pre-pay'} ${formatPrice(totalFees)} in fees`}
    />
  )
}

export const GasStationStepRow = () => {
  const gasStep = useAtomValue(gasStepAtom)
  const isUserRejectionError = useAtomValue(isUserRejectionErrorAtom)
  const isWarning = gasStep.error && isUserRejectionError

  if (!gasStep.isGasStationNeeded) {
    return null
  }

  return (
    <BasicStepRow
      title={<Title />}
      isActive={gasStep.isActive}
      isLoading={gasStep.isLoading}
      isError={gasStep.isError}
      isWarning={isWarning}
      isWaiting={gasStep.isSigning}
      isSuccess={gasStep.isSuccess}
    />
  )
}
